import type { FaireProductEntity } from "../../entity_types/product";

export const p_ag7e7bitpk: FaireProductEntity = {
  token: "p_ag7e7bitpk",
  type: "product",
  name: "Rib Knit Tassel Throw Blanket Adult Home (Organic Cotton)",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/a2c66e6d3c4426b63e7b86bf1d723d360441738febb3b00810cea65837238fc0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8046d0b64fbc888e2ee38a0f5970a24751dbeaafd2e15b23e5891f60b79da702.jpeg",
    "https://cdn.faire.com/fastly/d1fd635e3f7eb62b019782b5e32f2c7ca2c995551d0ed824550a82169e73c234.jpeg",
    "https://cdn.faire.com/fastly/8c1fa766a5dee1894cad1204dfa31e8f75bd4078605d6b5dfbfbaaf6fad2de92.jpeg",
    "https://cdn.faire.com/fastly/7b8cc55803ccfb289d85d83d4a9b3c15b791b3afa17de5be89b5237fb3a8cc69.jpeg",
    "https://cdn.faire.com/fastly/e0a21075bfcd7b832658b64d615b4c5e0fc98b1ef7f052d3dc67a99a696ca4a5.jpeg",
  ],
  priceDollars: 60,
  description:
    "100% organic cotton rib knit tassel throw blanket for the home, adult size.\nSize: approx 70x80 inches, 3.5 inch twisted tassels.\nUltra-Soft, luxurious, comfortable, warm, cozy, all-season, just the perfect weight.\nPure, natural, non-toxic, pesticide & chemical free formulation.\nEco-friendly & sustainable product.\nMulti-use - bed throw, sofa throw, meditation shawl, yoga blanket, baby blanket, travel blanket, stroller cover.\nIdeal gender neutral gift for a corporate gifting program.\nMachine washable, durable and long lasting.\nPremium quality yarn and knitted at a state of the art fairtrade certified facility in India.\nEthically made in India from small-farmer sourced organic cotton.\nAt Viverano, we make earth-friendly & luxurious pieces for everyday eco-chic comfort (gentle on you and gentle to the Earth).\n• Knitted from pure organic cotton.\n• Ultra soft, breathable & gentle to the skin.\n• Supporting small farmer livelihoods.\n• Family owned American brand.\n• Ethically produced in INDIA.",
  tags: [],
  msrpDollars: 120,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-13T18:02:28.539Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
